const SEOT_4733_PATHS = new Set([
  '/suv/midsize/',
  '/suv/hybrid/',
  '/suv/large/',
  '/suv/luxury/',
  '/suv/electric/',
  '/suv/small/',
  '/suv/3-row/',
  '/electric/awd/',
]);

export function getIsSeot4733(featureFlag, type, subtype) {
  return featureFlag && SEOT_4733_PATHS.has(`/${type}/${subtype}/`);
}
